import e from"styled-components";import{theme as i}from"../../../../../theme.js";const n=e.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: 0 ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
    height: 100%;
  }
`,o=e.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  min-height: 220px;
  overflow-y: auto;
  max-height: 300px;
  @media screen and (max-width: ${i.breakpoints.md}) {
    height: calc(100% - 32px - 56px);
    max-height: unset;
    min-height: unset;
  }

`,t=e.div`
  display: flex;
  align-items: center; 
  justify-content: space-between;
  border-radius: ${i.radius}px;
  padding: ${i.spacing*4}px;
  background-color: ${i.colors.gray[50]};
  > span {
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    color: ${i.colors.gray[500]};
  }
  > button {
    border: none;
    cursor: pointer;
    background-color: unset;
    padding: 0;
    > svg {
      width: 24px;
      height: 24px;
      > g, path {
        fill: ${i.colors.error[300]};
      }
    }
  }
`;export{n as Container,o as ListContainer,t as TagContainer};
